import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const DESTRUCTIVE_BUTTON_STYLE = {
  backgroundColor: '#FF0000',
  borderColor: '#FF0000',
  color: '#ffffff',
  transition: 'none',
  boxShadow: 'none',
};

const ResponderAlertModal = ({
  show = false,
  title = 'Confirm',
  message = '',
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm = () => {},
  onCancel = () => {},
  showCancel = true,
  showFooter = true,
  confirmVariant = 'danger',
  cancelVariant = 'primary',
  centered = true,
}) => {
  const isDestructive = confirmVariant === 'danger';

  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered={centered}
      className="responder-alert-modal"
      backdropClassName="responder-alert-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children ?? message}</Modal.Body>
      {showFooter && (
        <Modal.Footer>
          {showCancel ? (
            <Button variant={cancelVariant} onClick={onCancel}>
              {cancelLabel}
            </Button>
          ) : null}
          <Button
            variant={confirmVariant}
            style={isDestructive ? DESTRUCTIVE_BUTTON_STYLE : undefined}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ResponderAlertModal;
